module.exports = __webpack_public_path__ + "assets/img/32_617_big.49a8e652.jpg";